export default function () {
  return {
    client: {
      name: null,
      document: null,
      email: null,
      phone: null,
    },
    address: {
      zipCode: null,
      state: null,
      city: null,
      patio: null,
      complement: null,
      neighborhood: null,
      number: null,
      ibge: null,
    },
  };
}
